import React from 'react';
import moment from 'moment';
import { useTranslations } from '@lang';
import { DetailTitle } from '../../styled';
import { OccupancyContainer, OccupancyItem, TableDetailsContainer } from './TableMetadata.styles';
import { Item } from 'shared-types/Common';
type TableMetadataProps = {
  numberOfChildren: number;
  numberOfAdults: number;
  restaurantName: string;
  restaurant: string;
  tablesDisableChildBookings: boolean;
  item: Item;
};

export const TableMetadata: React.FC<TableMetadataProps> = ({
  numberOfChildren,
  numberOfAdults,
  restaurantName,
  restaurant,
  tablesDisableChildBookings,
  item,
}) => {
  const { t } = useTranslations();
  const dateTime = item.bookable?.ids.timeslot;
  const date = moment(dateTime).format('DD MMMM YYYY');
  const time = moment(dateTime).format('HH:mm');
  return (
    <>
      <TableDetailsContainer>
        <OccupancyContainer>
          <DetailTitle>{t('common.guests')}</DetailTitle>
          <div>
            <OccupancyItem>{t('basket.adults', { adults: numberOfAdults })}</OccupancyItem>
            {!tablesDisableChildBookings && !!numberOfChildren && (
              <OccupancyItem>{t('basket.children', { children: numberOfChildren })}</OccupancyItem>
            )}
          </div>
        </OccupancyContainer>
        <OccupancyContainer>
          <DetailTitle>{t('common.date')}</DetailTitle>
          <div>
            <OccupancyItem>{date}</OccupancyItem>
          </div>
        </OccupancyContainer>
        <OccupancyContainer>
          <DetailTitle>{t('common.time')}</DetailTitle>
          <div>
            <OccupancyItem>{time}</OccupancyItem>
          </div>
        </OccupancyContainer>
        <OccupancyContainer>
          <DetailTitle>{t('common.restaurant')}</DetailTitle>
          <div>{restaurantName || restaurant}</div>
        </OccupancyContainer>
      </TableDetailsContainer>
    </>
  );
};
